import Button from "@mui/material/Button";
import { useWindowSize } from "@uidotdev/usehooks";
import PropTypes from "prop-types";

export const ButtonNumber = ({
  title,
  style,
  onClick,
  isActive,
  isDefault,
}) => {
  const { width } = useWindowSize();
  let padding;
  let cornerRadius;
  if (width > 850) {
    padding = "10px 42px";
    cornerRadius = "24px";
  } else {
    padding = "10px 5px";
    cornerRadius = "30px";
  }
  const handleClick = () => {
    if (onClick) {
      onClick(); // Gọi callback onClick
    } else {
    }
  };
  return (
    <div>
      <Button
        variant="contained"
        onClick={handleClick}
        sx={{
          borderRadius: cornerRadius,
          padding: padding,
          backgroundColor: isActive
            ? "#565ADD"
            : isDefault
              ? "#565ADD"
              : "#fff",
          color: isActive ? "#fff" : isDefault ? "##fff" : "#565ADD",
          width: width < 639 ? "100%" : "auto",
          minWidth: width < 460 ? "60px" : undefined,
          fontSize: "18px",
          fontWeight: "semibold",
          textTransform: "none",
          boxShadow: "none",
          border: isActive ? "none" : isDefault ? "none" : "1px solid #565ADD",
          // boxShadow: "0px 12px 30px 0px rgba(24, 92, 255, 0.18)",

          "&:hover": {
            backgroundColor: "#565ADD",
            color: "#fff",
            //   border: "none",
          },
          ...style,
        }}
      >
        {title}
      </Button>
    </div>
  );
};
ButtonNumber.propTypes = {
  title: PropTypes.string,
  style: PropTypes.object,
  onClick: PropTypes.func,
  isActive: PropTypes.bool,
  isDefault: PropTypes.bool,
};
